import { useEffect, useRef, useState } from 'react';
import { Button, CircularProgress, Stack, Typography } from '@mui/material';
import CelebrationRounded from '@mui/icons-material/CelebrationRounded';
import ErrorOutlineRounded from '@mui/icons-material/ErrorOutlineRounded';
import { Link as RouterLink, useSearchParams } from 'react-router';
import { ApiError } from '@/api';
import { confirmaVinculo } from '@/features/notas/service';
import { primeiroNome } from '@/features/notas/texto';

/** Página aberta pelo link do e-mail. Funciona sem login (o aluno pode abrir no celular). */
export function ConfirmarPage() {
  const [params] = useSearchParams();
  const token = params.get('token') ?? '';
  const [estado, setEstado] = useState<
    { tipo: 'carregando' } | { tipo: 'ok'; nome: string } | { tipo: 'erro'; msg: string }
  >(
    token
      ? { tipo: 'carregando' }
      : { tipo: 'erro', msg: 'Link incompleto. Abra o link exatamente como veio no e-mail.' },
  );
  const feito = useRef(false);

  useEffect(() => {
    if (feito.current) return; // o token é de uso único: não confirmar duas vezes no StrictMode
    feito.current = true;
    if (!token) return;
    confirmaVinculo(token).then(
      (r) => setEstado({ tipo: 'ok', nome: r.nome }),
      (e) =>
        setEstado({
          tipo: 'erro',
          msg:
            (e instanceof ApiError && (e.data as { message?: string })?.message) ||
            'Não consegui confirmar agora.',
        }),
    );
  }, [token]);

  return (
    <Stack spacing={2.5} sx={{ alignItems: 'center', textAlign: 'center', py: 2 }}>
      {estado.tipo === 'carregando' && (
        <>
          <CircularProgress />
          <Typography>Confirmando…</Typography>
        </>
      )}
      {estado.tipo === 'ok' && (
        <>
          <CelebrationRounded color="primary" sx={{ fontSize: 56 }} />
          <Typography variant="h5" component="h1">
            Tudo certo, {primeiroNome(estado.nome)}!
          </Typography>
          <Typography color="text.secondary">
            O seu RA está confirmado. Entre com a mesma conta Google para ver o seu desempenho.
          </Typography>
          <Button variant="contained" component={RouterLink} to="/">
            Ver minhas notas
          </Button>
        </>
      )}
      {estado.tipo === 'erro' && (
        <>
          <ErrorOutlineRounded color="error" sx={{ fontSize: 56 }} />
          <Typography variant="h5" component="h1">
            Não deu para confirmar
          </Typography>
          <Typography color="text.secondary">{estado.msg}</Typography>
          <Button variant="contained" component={RouterLink} to="/">
            Ir para o painel
          </Button>
        </>
      )}
    </Stack>
  );
}
